module.exports = __webpack_public_path__ + "img/resumeOnboarding.acc8b0b4.png";